/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponentTypeEnum } from './componentTypeEnum';


export interface DeploymentComponent { 
    /**
     * Full name of the component.
     */
    full_name: string;
    type: ComponentTypeEnum;
}
export namespace DeploymentComponent {
}


